import {
  DeliverySystemApiClient,
  type QualificationReqPayload,
  type QualificationResponse,
  type LeadRequest,
} from '@highereducation/delivery-system';
import { getApiConfig } from '@de/services';

const clientCache = new Map<string, DeliverySystemApiClient>();

/**
 * Gets or creates a cached DeliverySystemApiClient instance
 */
function getClient(): DeliverySystemApiClient {
  const config = getApiConfig();
  const baseUrl = config.deliverySystemApiUrl;

  if (!baseUrl) {
    throw new Error('Delivery System API URL is not configured');
  }

  let client = clientCache.get(baseUrl);
  if (!client) {
    client = new DeliverySystemApiClient({ baseUrl });
    clientCache.set(baseUrl, client);
  }
  return client;
}

/**
 * Fetches lead qualifications using the v3 endpoint.
 *
 * @param body - The qualification request payload
 * @returns Promise resolving to the qualification response
 */
export const fetchLeadQualifications = async (
  body: QualificationReqPayload,
): Promise<QualificationResponse> => {
  const client = getClient();
  return client.postLeadQualifications(body);
};

/**
 * Fetches contact qualifications using the v4 endpoint.
 *
 * @param body - The lead request payload
 * @returns Promise resolving to the qualification response
 */
export const fetchContactQualifications = async (
  body: LeadRequest,
): Promise<QualificationResponse> => {
  const client = getClient();
  return client.postLeadQualify(body);
};
